import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 24px;
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 8px;
`;

export const LabelContainer = styled.div`
  display: flex;
  width: 240px;

  gap: 2px;
`;

export const ToggleContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const RestrictSupplierProductsContainer = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ModalDropdownItem = styled.div`
  width: 100%;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  justify-content: center;
`;
